import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  De_generateSickLeaveDocumentInput,
  useDeGenerateSickLeaveDocumentMutation as useDeGenerateSickLeaveDocumentMutationType,
} from "@/modules/patients/detail/sick-leave-certificate/de/services/__generated__/useDeGenerateSickLeaveDocumentMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const generateSickLeaveDocumentMutation = graphql`
  mutation useDeGenerateSickLeaveDocumentMutation($input: De_generateSickLeaveDocumentInput!) {
    de_generateSickLeaveDocument(input: $input) {
      de_SickLeave {
        id
        fileId
        ...deSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeGenerateSickLeaveDocumentMutationType>, "variables"> & {
  params: Pick<De_generateSickLeaveDocumentInput, "sickLeaveId">
}

const useDeGenerateSickLeaveDocumentMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeGenerateSickLeaveDocumentMutationType>(
    generateSickLeaveDocumentMutation,
    params,
  )
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: { patientId: patientById, sickLeaveId: config.params.sickLeaveId },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useDeGenerateSickLeaveDocumentMutation }
